import React from "react";

function Index({ data }) {
  return (
    <div>
      <ul
        style={{
          margin: "0 1.5%",
        }}
      >
        {data.split("\n").map((item, key) => (
          <li key={key}>
            <div
              className="content"
              style={{ fontWeight: "400" }}
              dangerouslySetInnerHTML={{ __html: item }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Index;
